import {IService, services} from "../constants/Routing";
import {useLocation} from "react-router-dom";
import {AppConfig} from "../Config";


export const useServiceDataByQuery = (serviceId?:IService['serviceId']) => {

  const location = useLocation();

  if (!!serviceId) {
    return services.find(service => service.serviceId === serviceId);
  } else {
    return services.find(service => service.url === location.pathname);
  }
}

export const useGlobalConfig = () => {
 return AppConfig.getConfig().global || {}
}